import {
    GET_ASSESSMENT_DETAILS_REQUEST,
    GET_ASSESSMENT_DETAILS_SUCCESS,
    GET_ASSESSMENT_DETAILS_FAILURE
} from '../actions';


const initialState = {};

const AssessmentDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ASSESSMENT_DETAILS_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_ASSESSMENT_DETAILS_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case GET_ASSESSMENT_DETAILS_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default AssessmentDetailsReducer